import api from "../api";
import TokenService from "./TokenService";
import { REFRESH_TOKEN } from "../queryKeys";

/* SERVICE */
class AuthService {
  async getRefreshToken() {
    const refreshToken = TokenService.getLocalRefreshToken();
    try {
      const response = await api.post(REFRESH_TOKEN, {
        refresh: refreshToken,
      });
      TokenService.storeAuthTokensInLocalStorage(
        response.data.access,
        response.data.refresh
      );
      return true;
    } catch (error) {
      return false;
    }
  }

  isAuthenticated() {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      return true;
    }
    return false;
  }

  logout() {
    TokenService.removeTokens();
  }
}

export default new AuthService();
